import { Component, inject } from '@angular/core';

import { DeviceDetectorService } from 'ngx-device-detector';

import { CtaPanel } from '@shared/components';

import { AnyImageWorks } from './any-image-works/any-image-works';
import { DemoCostOrComplexity } from './cost-or-complexity/demo-cost-or-complexity';
import { EvrnImageScene } from './evrn-image-scene/evrn-image-scene';
import { DemoEvrnMethod } from './evrn-method/demo-evrn-method';
import { FullEvrnDemo } from './full-evrn-demo/full-evrn-demo';
import { DemoHero } from './hero/demo-hero';
import { MobileDemo } from './mobile-demo/mobile-demo';
import { SceneShowcase } from './scene-showcase/scene-showcase';

@Component({
  selector: 'app-demo',
  imports: [
    DemoHero,
    EvrnImageScene,
    CtaPanel,
    DemoEvrnMethod,
    DemoCostOrComplexity,
    AnyImageWorks,
    SceneShowcase,
    MobileDemo,
    FullEvrnDemo,
  ],
  templateUrl: './demo.html',
})
export class Demo {
  isMobile = inject(DeviceDetectorService).isMobile();
}
